<label class="form-group-label" for="{{forInput}}">{{ _label | i18n}}&nbsp;<i class="fa fa-warning text-danger"
	x-ng-if="showError" tooltip-placement="right" tooltip-html-unsafe="{{errorText}}" tooltip-trigger="mouseenter"> </i> <i
	class="fa fa-question-circle text-info" x-ng-if="showHelp" tooltip-placement="right" uib-tooltip="{{_helpLabel | i18n}}"
	tooltip-trigger="mouseenter"> </i>
</label>